import { css } from "@compiled/react";

import { token } from "@atlaskit/tokens";

import { Picture } from "@/components/wpl/image/src/index.ts";
import { wacToken } from "@/libraries/design/foundations/index.ts";

const lightTextStyles = css({
    color: `${wacToken("color.neutral.light0")}`
});

export interface UniformsubProductProps {
    title: string;
    imageUrl: string;
    imageAlt: string;
    backgroundColor?: string;
}

const isDarkBackgroundColor = (color?: string): boolean => {
    return color ? ["#1868DB", "#101214"].includes(color) : false;
};

const UniformsubProduct = (props: UniformsubProductProps) => {
    return (
        <div
            css={css({
                display: "flex",
                flexDirection: "column",
                gap: token("space.050"),
                minWidth: "54px",
                padding: `0 ${token("space.100")} ${token("space.100")} ${token(
                    "space.100"
                )}`
            })}
        >
            <div
                css={css({
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                })}
            >
                <div
                    css={css({
                        margin: "9px",
                        height: "22.4px",
                        width: "22.4px"
                    })}
                >
                    <Picture
                        image={{
                            src: props.imageUrl,
                            alt: props.imageAlt
                        }}
                    />
                </div>
            </div>
            <span
                css={[
                    css({
                        textAlign: "center",
                        fontFamily: wacToken("font.charlie.text"),
                        fontSize: "12.6px",
                        fontStyle: "normal",
                        fontWeight: 400,
                        lineHeight: "14px"
                    }),
                    isDarkBackgroundColor(props.backgroundColor) &&
                        lightTextStyles
                ]}
            >
                {props.title}
            </span>
        </div>
    );
};

export default UniformsubProduct;
